import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FiatDepositEntryService } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit-entry.service";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "deposit-now",
	templateUrl: "./deposit-now-modal.component.html",
	styleUrls: ["./deposit-now-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositNowModalComponent implements OnInit {
	public constructor(
		private readonly fiatDepositEntryService: FiatDepositEntryService,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public ngOnInit(): void {
		this.rudderstackTracking("Insufficient Balance Notification Viewed");
	}

	public onClick(): void {
		this.rudderstackTracking("Insufficient Balance Deposit Tapped");
		this.fiatDepositEntryService.openDeposit();
	}

	private rudderstackTracking(event: string): void {
		this.segmentService.track({
			name: event,
			properties: {
				category: "Trading interaction"
			}
		});
		this.rudderstackService.track({
			name: event,
			properties: {
				category: "Trading interaction"
			}
		});
	}
}
